import styled from 'styled-components';
import * as UI from 'components/modules/UI/ui';

// export const Section = styled(UI.Section)`
//   position: relative;
//   display: flex;
//   flex-direction: column-reverse;
//   width: 100%;

//   background-repeat: no-repeat;
//   background-position: 0 0;
//   background-size: cover;
//   @media (min-width: 1024px) {
//     flex-direction: ${({ reversed }) => (reversed ? 'row-reverse' : 'row')};
//   }
// `;

export const Section = styled.section`
  width: 100%;
  height: auto;
  display: flex;
  background-color: ${({ backgroundColor }) => backgroundColor};
  position: relative;
  flex-direction: column-reverse;

  background-repeat: no-repeat;
  background-position: 0 0;
  background-size: cover;
  @media (min-width: 1024px) {
    display: flex;
    flex-direction: row;
    height: ${({ height }) => (height ? `${height}vh` : '90vh')};
    flex-direction: ${({ reversed }) => (reversed ? 'row-reverse' : 'row')};
  }

  @media (min-width: 1280px) and (min-height: 1300px) {
    height: 1235px;
  }

  @media (min-width: 1920px) and (max-height: 899px) {
    min-height: 600px;
  }
  @media (min-width: 1024px) and (max-height: 699px) {
    min-height: 500px;
  }
`;

export const BackgroundOverlay = styled(UI.BackgroundOverlayNarrow)``;

export const SliderWrapper = styled.div`
  position: relative;

  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin-top: 20px;
  margin-bottom: 70px;

  @media (min-width: 1024px) {
    width: 50%;
    margin-bottom: 2.5rem;
  }
`;

export const TextWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  width: 100%;
  overflow: hidden;
  background-color: ${({ backgroundColor }) => backgroundColor};
  @media (min-width: 1024px) {
    flex-direction: column;
    text-align: ${({ textHorizAlign }) => textHorizAlign};
    justify-content: ${({ textAlign }) => textAlign};
    width: 50%;
  }
`;

export const TextContainer = styled(UI.HalfContainerNarrow)``;



// WEBPACK FOOTER //
// ./src/components/modules/SliderMobileSection/styled.js